import React, { useState } from "react";
import { Button } from "@mui/material";

const TruncatedText = ({ text, maxLength = 100, maxLines = 3 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Se il testo è null o undefined, mostralo vuoto
  if (!text) {
    return <span>{""}</span>;
  }

  // Funzione per determinare se il contenuto è HTML
  const isHTML = (str) => {
    return /<\/?[a-z][\s\S]*>/i.test(str);
  };

  // Funzione per limitare il numero di righe
  const limitLines = (str, maxLines) => {
    const lines = str.split("\n");
    if (lines.length <= maxLines) {
      return str;
    }
    return lines.slice(0, maxLines).join("\n");
  };
  // Funzione per troncare il testo per caratteri e righe
  const getTruncatedText = (str) => {
    // Se è HTML, usa una logica diversa per il troncamento
    if (isHTML(str)) {
      // Per l'HTML, creiamo un elemento temporaneo per estrarre solo il testo
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = str;
      const textContent = tempDiv.textContent || tempDiv.innerText || "";
      
      // Se il testo è più lungo del limite, tronchiamo l'HTML originale in modo più intelligente
      if (textContent.length > maxLength) {
        // Troviamo una posizione di taglio che non rompa i tag HTML
        let truncatedHtml = str;
        let tempDiv2 = document.createElement("div");
        tempDiv2.innerHTML = str;
        
        // Estraiamo il testo e tronchiamo, poi proviamo a mapparlo sull'HTML
        const targetLength = maxLength;
        let currentLength = 0;
        let result = "";
        
        // Metodo semplice: tagliamo l'HTML a caratteri ma assicuriamoci di non rompere i tag
        for (let i = 0; i < str.length && currentLength < targetLength; i++) {
          const char = str[i];
          result += char;
          
          // Se non siamo dentro un tag HTML, contiamo il carattere
          if (char !== '<' && char !== '>') {
            const openTags = (result.match(/</g) || []).length;
            const closeTags = (result.match(/>/g) || []).length;
            
            // Solo se non siamo dentro un tag, contiamo il carattere
            if (openTags === closeTags) {
              currentLength++;
            }
          }
        }
        
        return result;
      }
      return str;
    }
    
    // Prima limita le righe
    const limitedByLines = limitLines(str, maxLines);
    // Poi limita i caratteri
    if (limitedByLines.length > maxLength) {
      return limitedByLines.substring(0, maxLength);
    }
    return limitedByLines;
  };

  // Controlla se il testo ha bisogno di essere troncato
  const needsTruncation = (() => {
    if (isHTML(text)) {
      // Per l'HTML, controlliamo la lunghezza del testo estratto
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = text;
      const textContent = tempDiv.textContent || tempDiv.innerText || "";
      return textContent.length > maxLength;
    }
    return text.length > maxLength || text.split("\n").length > maxLines;
  })();

  // Se non ha bisogno di troncamento, mostralo tutto
  if (!needsTruncation) {
    if (isHTML(text)) {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          style={{ whiteSpace: "pre-wrap" }}
        />
      );
    }
    return <span style={{ whiteSpace: "pre-wrap" }}>{text}</span>;
  }

  const truncatedText = getTruncatedText(text);

  return (
    <div style={{ lineHeight: "1.4" }}>
      {isHTML(text) ? (
        <div
          dangerouslySetInnerHTML={{
            __html: isExpanded ? text : truncatedText + (needsTruncation ? "..." : ""),
          }}
          style={{
            display: "inline-block",
            maxHeight: isExpanded ? "none" : `${maxLines * 1.4}em`, // Altezza basata sul numero di righe
            overflow: isExpanded ? "visible" : "hidden",
            whiteSpace: isExpanded ? "normal" : "normal",
            wordBreak: "break-word",
          }}
        />
      ) : (
        <span
          style={{
            display: "inline-block",
            maxHeight: isExpanded ? "none" : `${maxLines * 1.4}em`,
            overflow: isExpanded ? "visible" : "hidden",
            whiteSpace: isExpanded ? "pre-wrap" : "pre-wrap",
            wordBreak: "break-word",
            verticalAlign: "top",
          }}
        >
          {isExpanded ? text : truncatedText + "..."}
        </span>
      )}
      <Button
        size="small"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          minWidth: "auto",
          padding: "2px 6px",
          marginLeft: "8px",
          fontSize: "0.75rem",
          textTransform: "none",
          color: "#E61F29",
          verticalAlign: "top",
        }}
      >
        {isExpanded ? "mostra meno" : "mostra di più"}
      </Button>
    </div>
  );
};

export default TruncatedText;
